export enum EligibilitiesAndSelfRegEnum {
  EXTERNAL = 'External',
  NON_TM_LINK = 'NonTMLink',
  TM_LINK_REF_1 = 'TMLinkRef1',
  TM_LINK_REF_1_REF_2 = 'TMLinkRef1Ref2',
  NONE = 'none',
}
